import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import MotorDetail from "./pages/MotorDetail";
import Compare from "./pages/Compare";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsappFab from "./components/WhatsappFab";
import CompareBar from "./components/CompareBar";
import { CompareProvider } from "./lib/compareStore";
import { Toaster } from "sonner";
import "./App.css";

export default function App() {
  return (
    <HashRouter>
      <CompareProvider>
        <div className="min-h-screen flex flex-col bg-white">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/motor/:slug" element={<MotorDetail />} />
              <Route path="/compare" element={<Compare />} />
            </Routes>
          </main>
          <Footer />
          <CompareBar />
          <WhatsappFab />
          <Toaster position="top-center" richColors />
        </div>
      </CompareProvider>
    </HashRouter>
  );
}
